import Camera from './Camera';

export default Camera;
